<template>
  <p class="text-gray-700 text-sm mb-2">You've chosen a {{product.name}}
     for {{product.amount | tightCurrency }}
    <template v-if="flavours.length">
      with {{flavours.join(", ")}}
    </template>
    <template v-if="topper">
      with a Thank You Topper
    </template>
    <template v-if="bacon">
      without Maple Bacon
    </template>
  </p>
</template>

<script>
import { find, filter, map } from 'lodash'
export default {
  props: ['sku', 'chosenFlavours','topper', 'bacon'],
  computed: {
    product() {
      return find(this.$root.$data.products, {sku: this.sku })
    },
    flavours() {
      return map(filter(this.$root.$data.flavours, o => this.chosenFlavours.includes(o.id)), 'name')
    }
  },
}
</script>

<style>

</style>